/* eslint-disable react/button-has-type */
import React, { useRef, useEffect } from 'react';
import './LotDetails.css';
import { useSelector } from 'react-redux';
import LotDetails from './LotDetails';

const checkIfLotShouldShow = (filter, lot) => {
  const shippingReviewData = lot.shippingReviewData;
  if (!shippingReviewData) return false;
  const isManuallyModified = shippingReviewData.isLotModified;
  switch (filter) {
    case 'readyToConfirm':
      if (shippingReviewData.status === 'awaiting_approval' && isManuallyModified) {
        return true;
      }
      if (shippingReviewData.status === 'awaiting_approval' && shippingReviewData.objectsExtraction?.confidenceAll >= 0.8) {
        return true;
      }
      return false;
    case 'needsReview':
      return shippingReviewData.status === 'failed' || (shippingReviewData.status === 'awaiting_approval' && lot.shippingReviewData.objectsExtraction?.confidenceAll < 0.8 && !isManuallyModified);
    case 'all':
      return true;
    default:
      return false;
  }
};

const LotDetailsContainer = ({ filterSelected = 'all', openEditShippingModal, onConfirm }) => {
  const pollRef = useRef(null);
  useEffect(() => () => {
    if (pollRef.current) {
      Object.values(pollRef.current).forEach((interval) => clearInterval(interval));
    }
  }, []);

  const { lotsWithShippingData } = useSelector((state) => state.shippingReview);
  return lotsWithShippingData && lotsWithShippingData.map((lot) => {
    const isVisible = checkIfLotShouldShow(filterSelected, lot);
    return (
      <div key={lot.lotID} className={`lot-details-container ${isVisible ? '' : 'd-none'}`}>
        <LotDetails
          lotInfo={lot}
          openEditShippingModal={openEditShippingModal}
          onConfirm={onConfirm}
          ref={pollRef}
        />
      </div>
    );
  });
};

export default LotDetailsContainer;
